import { useSearchParams } from "react-router-dom";

export default function TabElement({ value, children }) {
  const [searchParams] = useSearchParams();
  return <div hidden={searchParams.get("tab") !== value}>{children}</div>;
}
